// Lib
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { endPresentationMode } from '../presentation/presentationActions';

// Utils

const mapDispatchToProps = (dispatch) => ({
    dispatchEndPresentationMode: () => dispatch(endPresentationMode()),
});

const PresentationModeFullScreenHandler = (props) => {
    const { dispatchEndPresentationMode } = props;

    useEffect(() => {
        const onFullscreenChange = (event) => {
            if (document.fullscreenElement || document.webkitFullscreenElement) return;
            dispatchEndPresentationMode();
        };

        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', onFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
        };
    }, []);

    return null;
};

PresentationModeFullScreenHandler.propTypes = {
    dispatchEndPresentationMode: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(PresentationModeFullScreenHandler);
